import React from 'react';

export default function SvgPeopleIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.23223 7.73223C1.70107 7.26339 2.33696 7 3 7H6C6.66304 7 7.29893 7.26339 7.76777 7.73223C8.23661 8.20107 8.5 8.83696 8.5 9.5V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V9.5C7.5 9.10218 7.34196 8.72064 7.06066 8.43934C6.77936 8.15804 6.39782 8 6 8H3C2.60218 8 2.22064 8.15804 1.93934 8.43934C1.65804 8.72064 1.5 9.10218 1.5 9.5V10.5C1.5 10.7761 1.27614 11 1 11C0.723858 11 0.5 10.7761 0.5 10.5V9.5C0.5 8.83696 0.763392 8.20107 1.23223 7.73223Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.5 2C3.67157 2 3 2.67157 3 3.5C3 4.32843 3.67157 5 4.5 5C5.32843 5 6 4.32843 6 3.5C6 2.67157 5.32843 2 4.5 2ZM2 3.5C2 2.11929 3.11929 1 4.5 1C5.88071 1 7 2.11929 7 3.5C7 4.88071 5.88071 6 4.5 6C3.11929 6 2 4.88071 2 3.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.01588 7.43957C9.08491 7.1722 9.35763 7.01142 9.625 7.08045C10.1613 7.21893 10.6365 7.53161 10.9759 7.9694C11.3152 8.40718 11.4996 8.94528 11.5 9.4992V10.4996C11.5 10.7757 11.2761 10.9996 11 10.9996C10.7239 10.9996 10.5 10.7757 10.5 10.4996V9.49976C10.4997 9.16747 10.3891 8.84469 10.1855 8.58207C9.98189 8.31939 9.6968 8.13179 9.375 8.0487C9.10763 7.97966 8.94684 7.70695 9.01588 7.43957Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.51562 1.44055C7.58412 1.17304 7.8565 1.0117 8.12402 1.0802C8.66178 1.21789 9.13842 1.53064 9.47879 1.96914C9.81917 2.40765 10.0039 2.94697 10.0039 3.50207C10.0039 4.05718 9.81917 4.5965 9.47879 5.035C9.13842 5.47351 8.66178 5.78626 8.12402 5.92395C7.8565 5.99244 7.58412 5.83111 7.51562 5.56359C7.44713 5.29608 7.60847 5.02369 7.87598 4.9552C8.19863 4.87259 8.48462 4.68494 8.68884 4.42183C8.89307 4.15873 9.00392 3.83514 9.00392 3.50207C9.00392 3.16901 8.89307 2.84542 8.68884 2.58231C8.48462 2.31921 8.19863 2.13156 7.87598 2.04895C7.60847 1.98045 7.44713 1.70807 7.51562 1.44055Z"
                fill="currentColor"
            />
        </svg>
    );
}
